import type { JSX } from 'react';

import { Button } from 'Components/Buttons/Buttons';
import { ICON_CLOSE, ICON_MOVE_OR_SCROLL_LEFT, ICON_MOVE_OR_SCROLL_RIGHT } from 'Config/Icons';

import styles from '../ConfigureIntegration.module.css';

export interface AwsConfigSetupWizardButtonRowProps {
    hasPreviousStep: boolean;
    hasNextStep: boolean;
    goToPreviousStep: () => void;
    goToNextStep: () => void;
    hideModal: () => void;
    children?: React.ReactNode;
}

/**
 * A generic row of buttons that is always present in the AWS Config setup wizard.
 * Close, Back, and Next buttons are handled uniformly for all wizard steps.
 * Additionally, each step can provide an actionable button that will be placed between the Back and Next buttons.
 */
export const AwsConfigSetupWizardButtonRow = (props: AwsConfigSetupWizardButtonRowProps): JSX.Element => {
    return (
        <div className={styles.buttonRowContainer}>
            <div className={styles.buttonPadding}>
                <Button variant="secondary" onClick={props.hideModal} fontAwesomeImage={ICON_CLOSE}>
                    Close
                </Button>
            </div>

            <div className={styles.buttonsRightContainer}>
                {props.hasPreviousStep && (
                    <div className={styles.buttonPadding}>
                        <Button variant="primary" onClick={props.goToPreviousStep} fontAwesomeImage={ICON_MOVE_OR_SCROLL_LEFT}>
                            BACK
                        </Button>
                    </div>
                )}

                {props.children}

                {props.hasNextStep && (
                    <div className={styles.buttonPadding}>
                        <Button variant="primary" onClick={props.goToNextStep} fontAwesomeImage={ICON_MOVE_OR_SCROLL_RIGHT}>
                            NEXT
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
};
